import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantAdditionalIncomePage = {
  alert: {
    error: 'applicant-additional-income-page.alert.error',
  },
  footer: {
    root: 'applicant-additional-income-page.footer.root',
  },
  form: {
    h1: 'applicant-additional-income-page.form.h1',
    h2: 'applicant-additional-income-page.form.h2',
    radioGroupRoot: 'applicant-additional-income-page.form.radio-group-root',
    radioOption1: 'applicant-additional-income-page.form.radio-option-1',
    radioOption2: 'applicant-additional-income-page.form.radio-option-2',
    root: 'applicant-additional-income-page.form.root',
    submitButton: 'applicant-additional-income-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
